import { render, staticRenderFns } from "./BatchAccountOfficerReassign.vue?vue&type=template&id=fac09682&"
import script from "./BatchAccountOfficerReassign.vue?vue&type=script&lang=js&"
export * from "./BatchAccountOfficerReassign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports